import React from 'react';
import PropTypes from 'prop-types';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero hero-triangle">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-multiline is-vcentered">
                        <div className="column is-offset-1-tablet is-10-tablet is-9-desktop">
                            <div className="title-wrapper animated fadeInLeft">
                                <h1 className="hidden">Hudson Pacific Properties Expertise</h1>
                                <div className="pre-title">Expertise</div>
                                <div className="big-title">
                                    DIFFERENTIATED CAPABILITIES SET <br/>OUR PLATFORM APART
                                </div>

                                <div className="hero-description">
                                    <p>
                                        Many real estate companies refer to their markets as ‘high barrier.’ We also like to think of our approach as high barrier. Our premier, full-service platform builds upon our unique industry relationships and expertise, and ensures we create outsized value through opportunistic acquisitions, award-winning ground-up development and repositionings, landmark leasing transactions and best-in-class operations. The world’s most innovative and creative companies demand modern, amenitized and sustainable office and studio space, and on all fronts we deliver.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Hero.propTypes = {
    isDesktop: PropTypes.bool,
};

export default Hero;
